import React from 'react';
import { Target } from 'lucide-react';
import { Progress } from "@/components/ui/progress";

function ProgressBar({ answeredCount, totalCount, percentage }) {
  return (
    <div className="rounded-xl border bg-card p-5" data-testid="review-progress-banner">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Target className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-foreground">Review Progress</h3>
            <p className="text-xs text-muted-foreground">
              {answeredCount} of {totalCount} questions answered
            </p>
          </div>
        </div>
        <div className="text-right">
          <span className="text-2xl font-bold text-primary">{percentage}%</span>
        </div>
      </div>
      <Progress value={percentage} className="h-2" />
    </div>
  );
}

export default ProgressBar;
